var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"loading"}},[_c('div',{attrs:{"id":"circle-1"}}),_c('div',{style:({backgroundImage: ("url(" + _vm.getLoadingPic + ")")}),attrs:{"id":"circle-2"}})])}
var staticRenderFns = []

export { render, staticRenderFns }